import {observer, React} from '@api'
import {useStores} from '@modules'
import {PrimaryIconButton} from 'centric-ui-components'

export const GroupAssortmentInternallyOrExternallyToggleButton = observer<{ className?: string}>(function GroupAssortmentInternallyOrExternallyToggleButton({className}) {
    const {catalog: {
      assortments: {selectedAssortment},
      settings: {assortment, assortment: {groupingBehavior}}}
    } = useStores()

  if (!selectedAssortment) return null

    return (<PrimaryIconButton className={className} icon='layout-hierarchy'
                               tooltip={'Group Within Assortments'}
                               tooltipPosition='bottom'
                               active={groupingBehavior === 'inside'}
                               onClick={() => assortment.groupingBehavior = groupingBehavior === 'inside' ? 'outside' : 'inside'} />
    )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/GroupByGroupAssortmentCards/GroupAssortmentInternallyOrExternallyToggleButton.tsx